import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { SlideMenuList } from '../../../asset/utils/SlideMenuList';
import { closeMenu, setAct } from '../../../store/MenuSlice';
import { Button } from '../../_atoms/Button';
import { Image } from '../../_atoms/Image';
import { SlideList } from '../../_molecules/SlideList';
import { ToolBox } from '../../_molecules/ToolBox';

const Aside = styled.aside`
  position: absolute;
  top: 0;
  z-index: 2;
  width: 162px;
  height: 100%;
  padding: 15px;
  background-color: #eee;
  filter: drop-shadow(5px 5px 5px rgba(0,0,0,0.20));
  transition: left 0.3s;
  text-align: center;

  ${(props) => (props.act ? 'left : 0;' : 'left : -162px;')}
`;

export const SlideMenu = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const onMenuSetting = () => {
    dispatch(setAct(!state.menu.act));
    dispatch(closeMenu());
  };

  return (
    <Aside act={state.menu.act}>
      <Button type="ebook" className={state.menu.act ? '' : 'act'} onClick={() => onMenuSetting()}/>
      <Image 
        src='https://content.chungchy.com/PhonicsHero/web_resource/images/ebook/left-menu_pop_logo.png'
        alt='Phonics Pop'
        type='logo'
      />
      {SlideMenuList[state.book.current_book].map((slideMenu, idx) => {
        return <SlideList list={slideMenu} first={idx}/>
      })}
      <ToolBox />
    </Aside>
  );
}